<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
<div *ngIf="!loading" class="patient-edit-shell flex flex-col h-auto min-h-0">

    <!-- HEADER INTERNO (Fixo no topo) -->
    <div class="bg-white rounded-lg border border-gray-200 p-3 mb-4 flex flex-col items-start gap-3 flex-shrink-0 patient-edit-header">
        <div class="flex flex-col">
            <span class="text-base font-semibold text-westetics-neutral-950">{{ patientData?.full_name || 'Carregando...' }}</span>
            <span class="text-xs text-westetics-neutral-600">{{ patientData?.email || '-' }}</span>
        </div>
        <div class="flex flex-wrap gap-2 w-full patient-edit-actions">
            <button 
                *ngIf="hasToShowAnamnese"
                (click)="onSendAnamnese()"
                class="patient-edit-action-btn flex-1 px-3 py-2 text-xs font-medium border text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg transition-colors text-center"
            >
                {{ vm.moduleName === 'PACIENTES' ? 'Enviar Anamnese' : 'Enviar Formulário' }}
            </button>

            <!-- Botão Gerar Documento com Anamnese (quando tem anamnese respondida) -->
            <button
                *ngIf="hasToShowAnamnese && vm.moduleName === 'PACIENTES'"
                (click)="onGenerateDocumentsWithAnamnese()"
                [disabled]="!hasAnsweredAnamnese"
                [title]="!hasAnsweredAnamnese ? 'O paciente não possui anamnese respondida. Envie uma anamnese para habilitar esta opção.' : ''"
                class="patient-edit-action-btn flex-1 px-3 py-2 text-xs font-medium rounded-lg transition-colors text-center"
                [ngClass]="{
                    'bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white': hasAnsweredAnamnese,
                    'bg-gray-300 text-gray-500 cursor-not-allowed': !hasAnsweredAnamnese
                }"
            >
                <span class="patient-edit-label-full">Gerar Documento com Anamnese</span>
                <span class="patient-edit-label-short">Gerar c/ Anamnese</span>
            </button>

            <!-- Botão Gerar Documentos Avulsos -->
            <button
                (click)="onGenerateStandaloneDocuments()"
                class="patient-edit-action-btn flex-1 px-3 py-2 text-xs font-medium border text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-50 transition-colors text-center"
            >
                <span class="patient-edit-label-full">{{ hasToShowAnamnese && vm.moduleName === 'PACIENTES' ? 'Gerar Documentos Avulsos' : 'Gerar Documentos' }}</span>
                <span class="patient-edit-label-short">{{ hasToShowAnamnese && vm.moduleName === 'PACIENTES' ? 'Docs Avulsos' : 'Gerar Docs' }}</span>
            </button>
        </div>
    </div>

    <!-- MENU DE SELEÇÃO (Horizontal - Topo) -->
    <div class="w-full flex-shrink-0 mb-4">
        <div class="bg-white rounded-lg border border-gray-200 p-2 sm:p-3">
            <!-- Menu horizontal (tabs) -->
            <nav class="grid grid-cols-2 sm:flex gap-1 sm:gap-2">
                <!-- Dados Pessoais -->
                <a 
                    (click)="activeSection = 'dadosPessoais'"
                    class="flex items-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-lg cursor-pointer transition-colors"
                    [ngClass]="activeSection === 'dadosPessoais' ? 'bg-westetics-purple-100 text-westetics-purple-800' : 'hover:bg-gray-50 text-westetics-neutral-800'"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z" fill="currentColor"/>
                    </svg>
                    <span class="text-xs sm:text-sm font-medium">Dados Pessoais</span>
                </a>

                <!-- Anamnese / Formulários -->
                <a 
                    *ngIf="hasToShowAnamnese"
                    (click)="activeSection = 'anamnese'"
                    class="flex items-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-lg cursor-pointer transition-colors"
                    [ngClass]="activeSection === 'anamnese' ? 'bg-westetics-purple-100 text-westetics-purple-800' : 'hover:bg-gray-50 text-westetics-neutral-800'"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z" fill="currentColor"/>
                    </svg>
                    <span class="text-xs sm:text-sm font-medium">{{ vm.moduleName === 'PACIENTES' ? 'Anamnese' : 'Formulários' }}</span>
                </a>

                <!-- Documentos -->
                <a 
                    (click)="activeSection = 'documentos'"
                    class="flex items-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-lg cursor-pointer transition-colors"
                    [ngClass]="activeSection === 'documentos' ? 'bg-westetics-purple-100 text-westetics-purple-800' : 'hover:bg-gray-50 text-westetics-neutral-800'"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z" fill="currentColor"/>
                    </svg>
                    <span class="text-xs sm:text-sm font-medium">Documentos</span>
                </a>

                <!-- Planos de Tratamento -->
                <a 
                    *ngIf="vm.moduleName === 'PACIENTES' && hasTreatmentPlanAccess"
                    (click)="activeSection = 'planosTratamento'"
                    class="flex items-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-lg cursor-pointer transition-colors"
                    [ngClass]="activeSection === 'planosTratamento' ? 'bg-westetics-purple-100 text-westetics-purple-800' : 'hover:bg-gray-50 text-westetics-neutral-800'"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17 12H7V14H17V12ZM17 8H7V10H17V8ZM14 16H7V18H14V16Z" fill="currentColor"/>
                    </svg>
                    <span class="text-xs sm:text-sm font-medium">Planos de Tratamento</span>
                </a>
            </nav>
        </div>
    </div>

    <!-- CONTEÚDO PRINCIPAL -->
    <div class="flex-1 min-w-0 overflow-y-auto">

        <!-- ========== DADOS PESSOAIS ========== -->
        <div *ngIf="activeSection === 'dadosPessoais'" class="max-w-full lg:max-w-[624px] mx-auto">
            <form [formGroup]="patientForm" (ngSubmit)="onSubmit()">
                
                <!-- DADOS OBRIGATÓRIOS -->
                <div class="border-b pb-3 sm:pb-4">
                    <p class="font-medium text-sm sm:text-base text-westetics-neutral-950">
                        Dados Obrigatórios*
                    </p>
                    <p class="text-xs sm:text-sm text-westetics-neutral-800 mt-1 sm:mt-2">
                        Informe os dados obrigatórios
                    </p>
                </div>

                <!-- Nome do Paciente -->
                <div class="border-b pb-3 sm:pb-4 mt-3 sm:mt-4">
                    <label for="name" class="block mb-1 sm:mb-2 text-xs sm:text-sm font-medium text-westetics-neutral-950">
                        Nome do {{vm.moduleNameInSingular}}*
                    </label>
                    <input
                        type="text"
                        id="name"
                        formControlName="name"
                        [placeholder]="'Insira o nome do ' + vm.moduleNameInSingular"
                        class="bg-gray-50 border border-gray-300 text-neutral-500 text-xs sm:text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2 sm:p-2.5"
                        [ngClass]="{'border-red-500': patientForm.get('name')?.invalid && patientForm.get('name')?.touched}"
                    />
                    <span class="text-red-600 text-xs sm:text-sm" *ngIf="patientForm.get('name')?.invalid && patientForm.get('name')?.touched">
                        Insira um nome válido.
                    </span>
                </div>

                <!-- DADOS NÃO-OBRIGATÓRIOS -->

                <div class="border-b pb-3 sm:pb-4 mt-4 sm:mt-6">
                    <p class="font-medium text-sm sm:text-base text-westetics-neutral-950">
                        Dados Não-Obrigatórios
                    </p>
                    <p class="text-xs sm:text-sm text-westetics-neutral-800 mt-1 sm:mt-2">
                        Complete o cadastro do {{vm.moduleNameInSingular}} assim que possível! Isso facilita na geração de documentos.
                    </p>
                </div>

                <!-- Paciente Modelo (apenas quando módulo PACIENTES) -->
                <div class="border-b pb-4 mt-4" *ngIf="showModelPatientCheckbox && vm.moduleName === 'PACIENTES'">
                    <label class="flex items-center gap-3 cursor-pointer">
                        <input 
                            type="checkbox" 
                            formControlName="isModelPatient" 
                            class="w-4 h-4 accent-westetics-blue"
                        >
                        <span class="text-sm font-medium text-westetics-neutral-950">É paciente modelo</span>
                    </label>
                </div>

                <!-- É estrangeiro? -->
                <div class="border-b pb-4 mt-4">
                    <p class="font-medium text-sm text-westetics-neutral-950">
                        É estrangeiro?
                    </p>
                    <div class="mt-3 flex gap-6">
                        <label class="flex items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                formControlName="isForeigner"
                                [value]="true"
                                class="w-4 h-4 accent-westetics-blue"
                            />
                            <span class="text-sm font-normal text-westetics-neutral-800">Sim</span>
                        </label>
                        <label class="flex items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                formControlName="isForeigner"
                                [value]="false"
                                class="w-4 h-4 accent-westetics-blue"
                            />
                            <span class="text-sm font-normal text-westetics-neutral-800">Não</span>
                        </label>
                    </div>
                </div>

                <!-- Email -->
                <div class="border-b pb-3 sm:pb-4 mt-3 sm:mt-4">
                    <label for="email" class="block mb-1 sm:mb-2 text-xs sm:text-sm font-medium text-westetics-neutral-950">
                        Email
                    </label>
                    <input
                        type="email"
                        id="email"
                        formControlName="email"
                        [placeholder]="'Insira o email do ' + vm.moduleNameInSingular"
                        class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        [ngClass]="{'border-red-500': patientForm.get('email')?.invalid && patientForm.get('email')?.touched}"
                    />
                    <span class="text-red-600 text-sm" *ngIf="patientForm.get('email')?.errors?.['emailTld'] && patientForm.get('email')?.touched">
                        Insira um email válido (ex: nome@dominio.com).
                    </span>
                    <span class="text-red-600 text-sm" *ngIf="patientForm.get('email')?.errors?.['api']">
                        {{ patientForm.get('email')?.errors?.['api'] }}
                    </span>
                </div>

                <!-- Telefone -->
                <div class="border-b pb-4 mt-4">
                    <label for="phone" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                        Telefone
                    </label>
                    <div class="flex items-center w-full">
                        <button 
                            type="button"
                            (click)="onClickPhoneCountryButton()"
                            class="flex-shrink-0 gap-1 inline-flex items-center py-2.5 px-2 text-xs font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100"
                        >
                            <img [src]="getSelectedPhoneCountry().img" alt="flag" class="w-5" />
                            ({{getSelectedPhoneCountry().ddi}})
                            <svg class="w-2.5 h-2.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
                            </svg>
                        </button>
                        
                        <!-- Dropdown de países -->
                        <div *ngIf="isDropdownPhoneOpen">
                            <div (click)="onClickPhoneCountryButton()" class="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
                            <div class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 max-h-80 w-[20rem] overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow-lg">
                                <div class="px-4 py-2 sticky top-0 bg-white z-10">
                                    <input 
                                        type="text" 
                                        placeholder="Buscar país ou DDI..."
                                        class="w-full px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-westetics-blue focus:border-westetics-blue"
                                        (input)="filterPhoneCountries($event)" 
                                    />
                                </div>
                                <ul class="py-2 text-sm text-gray-700">
                                    <li *ngFor="let country of filteredPhoneCountries">
                                        <button 
                                            (click)="onClickSelectPhoneCountry(country)" 
                                            type="button"
                                            class="inline-flex gap-2 w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        >
                                            <img [src]="country.img" alt="flag" class="w-5" />
                                            <span>{{country.pais}} ({{country.ddi}})</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <input 
                            type="text" 
                            id="phone"
                            formControlName="phone"
                            placeholder="11900000000"
                            inputmode="tel"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5 ml-2"
                        />
                    </div>
                </div>

                <!-- Data de Nascimento e Profissão -->
                <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
                    <div>
                        <label for="birthDate" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Data de Nascimento
                        </label>
                        <input
                            type="text"
                            id="birthDate"
                            formControlName="birthDate"
                            placeholder="DD/MM/AAAA"
                            (input)="onBirthDateInput($event)"
                            maxlength="10"
                            inputmode="numeric"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                    <div>
                        <label for="profession" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            {{ vm.moduleName === 'ALUNOS' ? 'Profissão e nº do conselho profissional' : 'Profissão' }}
                        </label>
                        <input
                            type="text"
                            id="profession"
                            formControlName="profession"
                            [placeholder]="'Insira a profissão do ' + vm.moduleNameInSingular"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                </div>

                <!-- Estado Civil -->
                <div class="border-b pb-4 mt-4">
                    <app-custom-dropdown
                        id="maritalStatus"
                        formControlName="maritalStatus"
                        label="Estado Civil"
                        placeholder="Selecione uma opção"
                        [options]="maritalStatusOptions"
                    ></app-custom-dropdown>
                </div>

                <!-- Conta do Instagram -->
                <div class="border-b pb-4 mt-4">
                    <label for="instagramAccount" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                        Conta do Instagram
                    </label>
                    <input
                        type="text"
                        id="instagramAccount"
                        formControlName="instagramAccount"
                        placeholder="@usuario"
                        class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                    />
                </div>

                <!-- RG e CPF -->
                <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
                    <div>
                        <label for="rg" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            RG
                        </label>
                        <input
                            type="text"
                            id="rg"
                            formControlName="rg"
                            [placeholder]="'Insira o RG do ' + vm.moduleNameInSingular"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                    <div>
                        <label for="cpf" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            {{ vm.moduleName === 'ALUNOS' ? 'CPF/CNPJ' : 'CPF' }}
                        </label>
                        <input
                            type="text"
                            id="cpf"
                            formControlName="cpf"
                            [placeholder]="vm.moduleName === 'ALUNOS' ? 'Digite CPF ou CNPJ' : 'Digite CPF'"
                            (input)="onCpfCnpjInput($event)"
                            inputmode="numeric"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                            [ngClass]="{'border-red-500': patientForm.get('cpf')?.invalid && patientForm.get('cpf')?.touched}"
                        />
                        <span class="text-red-600 text-sm" *ngIf="(patientForm.get('cpf')?.errors?.['cpfCnpjInvalid'] || patientForm.get('cpf')?.errors?.['cpfInvalid']) && patientForm.get('cpf')?.touched">
                            {{ vm.moduleName === 'ALUNOS' ? 'Insira um CPF ou CNPJ válido.' : 'Insira um CPF válido.' }}
                        </span>
                    </div>
                </div>

                <!-- DADOS DO RESPONSÁVEL LEGAL (exibido apenas para menores de idade) -->
                <ng-container *ngIf="isMinor">
                    <div class="border-b pb-4 mt-6">
                        <p class="font-medium text-base text-westetics-neutral-950">
                            Dados do Responsável Legal
                        </p>
                        <p class="text-xs text-westetics-neutral-600 mt-1">
                            Informações do responsável legal para assinatura de documentos (paciente menor de idade)
                        </p>
                    </div>

                    <!-- Nome e CPF do Responsável -->
                    <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
                        <div>
                            <label for="guardianName" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                                Nome do Responsável
                            </label>
                            <input
                                type="text"
                                id="guardianName"
                                formControlName="guardianName"
                                placeholder="Nome completo do responsável"
                                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                            />
                        </div>
                        <div>
                            <label for="guardianCpf" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                                CPF do Responsável
                            </label>
                            <input
                                type="text"
                                id="guardianCpf"
                                formControlName="guardianCpf"
                                placeholder="CPF do responsável"
                                inputmode="numeric"
                                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                                [ngClass]="{'border-red-500': patientForm.get('guardianCpf')?.invalid && patientForm.get('guardianCpf')?.touched}"
                            />
                            <span class="text-red-600 text-sm" *ngIf="patientForm.get('guardianCpf')?.errors?.['cpfInvalid'] && patientForm.get('guardianCpf')?.touched">
                                Insira um CPF válido.
                            </span>
                        </div>
                    </div>

                    <!-- Telefone do Responsável -->
                    <div class="border-b pb-4 mt-4">
                        <label for="guardianPhone" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Telefone do Responsável
                        </label>
                        <div class="flex items-center w-full">
                            <button 
                                type="button"
                                (click)="onClickGuardianPhoneCountryButton()"
                                class="flex-shrink-0 gap-1 inline-flex items-center py-2.5 px-2 text-xs font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100"
                            >
                                <img [src]="getSelectedGuardianPhoneCountry().img" alt="flag" class="w-5" />
                                ({{getSelectedGuardianPhoneCountry().ddi}})
                                <svg class="w-2.5 h-2.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
                                </svg>
                            </button>
                            
                            <!-- Dropdown de países do responsável -->
                            <div *ngIf="isDropdownGuardianPhoneOpen">
                                <div (click)="onClickGuardianPhoneCountryButton()" class="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
                                <div class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 max-h-80 w-[20rem] overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow-lg">
                                    <div class="px-4 py-2 sticky top-0 bg-white z-10">
                                        <input 
                                            type="text" 
                                            placeholder="Buscar país ou DDI..."
                                            class="w-full px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-westetics-blue focus:border-westetics-blue"
                                            (input)="filterGuardianPhoneCountries($event)" 
                                        />
                                    </div>
                                    <ul class="py-2 text-sm text-gray-700">
                                        <li *ngFor="let country of filteredGuardianPhoneCountries">
                                            <button 
                                                (click)="onClickSelectGuardianPhoneCountry(country)" 
                                                type="button"
                                                class="inline-flex gap-2 w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >
                                                <img [src]="country.img" alt="flag" class="w-5" />
                                                <span>{{country.pais}} ({{country.ddi}})</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            
                            <input 
                                type="text" 
                                id="guardianPhone"
                                formControlName="guardianPhone"
                                placeholder="11900000000"
                                inputmode="tel"
                                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5 ml-2"
                            />
                        </div>
                    </div>
                </ng-container>

                <!-- ENDEREÇO -->
                <div class="border-b pb-4 mt-6">
                    <p class="font-medium text-base text-westetics-neutral-950">
                        Endereço
                    </p>
                </div>

                <!-- CEP e Rua -->
                <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
                    <div>
                        <label for="zipCode" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            {{ patientForm.get('isForeigner')?.value ? 'Código Postal/ZIP Code' : 'CEP' }}
                        </label>
                        <input
                            type="text"
                            id="zipCode"
                            formControlName="zipCode"
                            [maxlength]="patientForm.get('isForeigner')?.value ? 20 : 9"
                            [placeholder]="patientForm.get('isForeigner')?.value ? 'Insira o Código Postal / ZIP Code' : 'Insira o CEP (00000-000)'"
                            (input)="onCepInput($event)"
                            (change)="cepOnChange()"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                    <div>
                        <label for="street" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Rua
                        </label>
                        <input
                            type="text"
                            id="street"
                            formControlName="street"
                            placeholder="Insira a Rua"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                </div>

                <!-- Número e Complemento -->
                <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
                    <div>
                        <label for="number" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Número
                        </label>
                        <input
                            type="text"
                            id="number"
                            formControlName="number"
                            placeholder="Insira o número"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                    <div>
                        <label for="complement" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Complemento
                        </label>
                        <input
                            type="text"
                            id="complement"
                            formControlName="complement"
                            placeholder="Insira o complemento"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                </div>

                <!-- Bairro e Cidade -->
                <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
                    <div>
                        <label for="neighborhood" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Bairro
                        </label>
                        <input
                            type="text"
                            id="neighborhood"
                            formControlName="neighborhood"
                            placeholder="Insira o Bairro"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                    <div>
                        <label for="city" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Cidade
                        </label>
                        <input
                            type="text"
                            id="city"
                            formControlName="city"
                            placeholder="Insira a Cidade"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                </div>

                <!-- Estado e País -->
                <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
                    <div>
                        <label for="state" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            Estado
                        </label>
                        <input
                            type="text"
                            id="state"
                            formControlName="state"
                            placeholder="Insira o Estado"
                            class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
                        />
                    </div>
                    <div>
                        <label for="country" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                            País
                        </label>
                        <button 
                            type="button"
                            (click)="onClickCountryButton()"
                            class="flex justify-between w-full items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-50 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100"
                        >
                            <div class="flex gap-2 items-center">
                                <img [src]="getSelectedCountry().img" alt="flag" class="w-5" />
                                {{getSelectedCountry().pais}}
                            </div>
                            <svg class="w-2.5 h-2.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
                            </svg>
                        </button>
                        
                        <!-- Dropdown de países -->
                        <div *ngIf="isDropdownCountryOpen">
                            <div (click)="onClickCountryButton()" class="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
                            <div class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 max-h-80 w-[20rem] overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow-lg">
                                <div class="px-4 py-2 sticky top-0 bg-white z-10">
                                    <input 
                                        type="text" 
                                        placeholder="Buscar país..."
                                        class="w-full px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-westetics-blue focus:border-westetics-blue"
                                        (input)="filterCountries($event)" 
                                    />
                                </div>
                                <ul class="py-2 text-sm text-gray-700">
                                    <li *ngFor="let country of filteredCountries">
                                        <button 
                                            (click)="onClickSelectCountry(country)" 
                                            type="button"
                                            class="inline-flex gap-2 w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        >
                                            <img [src]="country.img" alt="flag" class="w-5" />
                                            <span>{{country.pais}}</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Botões -->
                <div class="flex justify-between my-6">
                    <button
                        type="button"
                        (click)="onCancel()"
                        class="w-[48%] py-[10px] text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg border "
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        class="w-[48%] py-[10px] bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg"
                    >
                        Salvar
                    </button>
                </div>
            </form>
        </div>

        <!-- ========== ANAMNESE ========== -->
        <div *ngIf="activeSection === 'anamnese'">
            
            <!-- Tabela de Anamneses - DESKTOP -->
            <div class="hidden md:block overflow-x-auto rounded-lg">
                <table class="w-full text-sm text-left text-gray-500 mb-4">
                    <thead class="text-xs text-westetics-neutral-900 bg-westetics-neutral-300">
                        <tr class="text-left">
                            <th scope="col" class="px-4 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="changeAnamneseOrdernation('createdAt')">
                                Data de envio
                                <fa-icon [icon]="anamneseOrderBy === 'createdAt' ? anamneseSortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1" [ngClass]="{'text-westetics-purple-800': anamneseOrderBy === 'createdAt'}"></fa-icon>
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="changeAnamneseOrdernation('patientName')">
                                Nome
                                <fa-icon [icon]="anamneseOrderBy === 'patientName' ? anamneseSortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1" [ngClass]="{'text-westetics-purple-800': anamneseOrderBy === 'patientName'}"></fa-icon>
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="changeAnamneseOrdernation('patientEmail')">
                                Email
                                <fa-icon [icon]="anamneseOrderBy === 'patientEmail' ? anamneseSortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1" [ngClass]="{'text-westetics-purple-800': anamneseOrderBy === 'patientEmail'}"></fa-icon>
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="changeAnamneseOrdernation('patientPhoneNumber')">
                                Telefone
                                <fa-icon [icon]="anamneseOrderBy === 'patientPhoneNumber' ? anamneseSortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1" [ngClass]="{'text-westetics-purple-800': anamneseOrderBy === 'patientPhoneNumber'}"></fa-icon>
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="changeAnamneseOrdernation('isAnswered')">
                                Status
                                <fa-icon [icon]="anamneseOrderBy === 'isAnswered' ? anamneseSortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1" [ngClass]="{'text-westetics-purple-800': anamneseOrderBy === 'isAnswered'}"></fa-icon>
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium text-sm">
                                Ações
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let anamnese of anamneses" class="border-b hover:bg-gray-50">
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{anamnese.created_at | date: 'dd/MM/yyyy HH:mm'}}
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{anamnese.patient.full_name}}
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{anamnese.patient.email || '-'}}
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{anamnese.patient.phone || '-'}}
                            </td>
                            <td class="p-4 text-sm text-nowrap text-center">
                            <span
                                class="inline-flex items-center justify-center px-2 py-1 rounded-full text-xs font-medium"
                                [ngClass]="anamnese.is_answered 
                                ? 'bg-westetics-purple-300 text-white' 
                                : 'bg-red-300 text-white'">
                                {{ anamnese.is_answered ? 'Preenchido' : 'Não Preenchido' }}
                            </span>
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                <div class="flex gap-3">
                                    <button class="cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600" (click)="viewAnamnese(anamnese)">
                                        <fa-icon [icon]="faEye"></fa-icon>
                                    </button>
                                    <button *ngIf="!anamnese.is_answered" class="cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600" (click)="deleteAnamnese(anamnese.id || '')">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="anamneses.length === 0">
                            <td colspan="6" class="p-8 text-center text-gray-500">
                                Nenhum {{ vm.moduleName === 'PACIENTES' ? 'anamnese' : 'formulário' }} encontrado.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Cards de Anamneses - MOBILE -->
            <div class="md:hidden space-y-3 mb-4">
                <div *ngFor="let anamnese of anamneses" 
                     class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
                    <div class="flex justify-between items-start mb-3">
                        <div class="min-w-0 flex-1">
                            <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{anamnese.patient.full_name}}</h3>
                            <p class="text-xs text-westetics-neutral-600 truncate">{{anamnese.patient.email || '-'}}</p>
                        </div>
                        <div class="flex gap-2">
                            <button
                                (click)="viewAnamnese(anamnese)"
                                class="p-2 text-westetics-neutral-600 hover:text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                            >
                                <fa-icon [icon]="faEye"></fa-icon>
                            </button>
                            <button *ngIf="!anamnese.is_answered"
                                (click)="deleteAnamnese(anamnese.id || '')"
                                class="p-2 text-westetics-neutral-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            >
                                <fa-icon [icon]="faTrash"></fa-icon>
                            </button>
                        </div>
                    </div>
                    <div class="grid grid-cols-2 gap-2 text-xs">
                        <div>
                            <span class="text-westetics-neutral-500">Data:</span>
                            <span class="ml-1 text-westetics-neutral-900">{{anamnese.created_at | date: 'dd/MM/yyyy'}}</span>
                        </div>
                        <div>
                            <span class="text-westetics-neutral-500">Telefone:</span>
                            <span class="ml-1 text-westetics-neutral-900">{{anamnese.patient.phone || '-'}}</span>
                        </div>
                        <div class="col-span-2">
                            <span class="text-westetics-neutral-500">Status:</span>
                            <span class="ml-1 font-medium" [ngClass]="anamnese.is_answered ? 'text-green-600' : 'text-red-500'">
                                {{anamnese.is_answered ? 'Preenchido' : 'Não Preenchido'}}
                            </span>
                        </div>
                    </div>
                </div>
                <div *ngIf="anamneses.length === 0" class="bg-white rounded-lg border border-gray-200 p-8 text-center text-gray-500">
                    Nenhum {{ vm.moduleName === 'PACIENTES' ? 'anamnese' : 'formulário' }} encontrado.
                </div>
            </div>

                <!-- Paginação Anamnese -->
                <div *ngIf="anamneses.length > 0 && anamneseTotalPages > 1" class="flex flex-col sm:flex-row items-center justify-between gap-4 py-4 px-2 sm:px-5">
                    <!-- Info de resultados -->
                    <div class="text-xs sm:text-sm text-gray-600">
                        Página {{ anamneseCurrentPage + 1 }} de {{ anamneseTotalPages }}
                    </div>
                    
                    <!-- Controles de paginação -->
                    <div class="flex items-center gap-1 sm:gap-2">
                        <!-- Botão Anterior -->
                        <button (click)="anamnesePrevious()" 
                                [disabled]="anamneseCurrentPage === 0"
                                [ngClass]="{'opacity-50 cursor-not-allowed': anamneseCurrentPage === 0}"
                                class="px-2 sm:px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                            </svg>
                        </button>
                        
                        <!-- Números das páginas -->
                        <div class="flex items-center gap-1">
                            <ng-container *ngFor="let page of generatePagination(anamneseCurrentPage + 1, anamneseTotalPages)">
                                <button
                                    (click)="anamneseNavigateTo(page)"
                                    [ngClass]="{
                                        'bg-westetics-purple-600 text-white': page === anamneseCurrentPage + 1,
                                        'hover:bg-gray-50': page !== anamneseCurrentPage + 1
                                    }"
                                    class="min-w-[32px] sm:min-w-[36px] px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-300 rounded-md transition-colors text-xs sm:text-sm">
                                    {{ page }}
                                </button>
                            </ng-container>
                        </div>
                        
                        <!-- Botão Próximo -->
                        <button (click)="anamneseNext()" 
                                [disabled]="anamneseCurrentPage + 1 >= anamneseTotalPages"
                                [ngClass]="{'opacity-50 cursor-not-allowed': anamneseCurrentPage + 1 >= anamneseTotalPages}"
                                class="px-2 sm:px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    </div>

                    <!-- Seletor de itens por página -->
                    <div class="flex items-center gap-2 text-xs sm:text-sm">
                        <span class="text-gray-600">Por página:</span>
                        <select [value]="anamnesePageSize" (change)="changeAnamnesePageSize($event)"
                                class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                        </select>
                    </div>
                </div>
        </div>

        <!-- ========== DOCUMENTOS ========== -->
        <div *ngIf="activeSection === 'documentos'">
            
            <!-- Tabela de Documentos - DESKTOP -->
            <div class="hidden md:block overflow-x-auto rounded-lg">
                <table class="w-full text-sm text-left text-gray-500 mb-4">
                    <thead class="text-xs text-westetics-neutral-900 bg-westetics-neutral-300">
                        <tr class="text-left">
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Data de envio
                            </th>
                            <th *ngIf="vm.moduleName === 'PACIENTES'" scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Procedimento
                            </th>
                            <th *ngIf="vm.moduleName === 'PACIENTES'" scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Profissional
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Valor Total
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Contratos
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Status
                            </th>
                            <!-- Status column removed per request -->
                            <th scope="col" class="px-4 py-2 font-medium text-sm">
                                Ações
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let document of documents" class="border-b hover:bg-gray-50">
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{document.answered_at | date: 'dd/MM/yyyy'}}
                            </td>
                            <td *ngIf="vm.moduleName === 'PACIENTES'" class="p-4 text-sm text-westetics-neutral-950">
                                {{document.procedure_name || '-'}}
                            </td>
                            <td *ngIf="vm.moduleName === 'PACIENTES'" class="p-4 text-sm text-westetics-neutral-950">
                                {{document.professional_name || '-'}}
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{document.total_value ? (document.total_value | currency:'BRL':'symbol':'1.2-2') : '-'}}
                            </td>
                            <td colSpan="2" class="p-4">
  <div *ngFor="let contract of document.autentique_info_list; index as i">
    <div
      class="flex w-full gap-4 py-2 items-center"
      [ngClass]="{ 'border-b border-gray-200': i !== document.autentique_info_list.length - 1 }"
    >
      <div
        class="flex w-1/2 items-center gap-2 cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600 hover:font-medium text-sm"
        (click)="openContract(contract.document_id)"
      >
        <span>{{ contract.document_name }}</span>
        <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
      </div>

      <div class="flex w-1/2 items-center justify-center">
        <span
          class="px-2 py-2 rounded-full text-xs font-medium !text-white"
          [ngClass]="{
            'bg-westetics-purple-300': contract.status === 'SIGNED',
            'bg-red-300': contract.status === 'PENDING' || contract.status === 'NOT_SIGNED',
            'bg-yellow-300':
              contract.status === 'SIGNED_ONLY_BY_RESPONSIBLE' ||
              contract.status === 'SIGNED_ONLY_BY_CLIENT' ||
              contract.status === 'PENDING_RESPONSIBLE',
            'bg-blue-300': getContractStatus(contract.status).message === 'Pendente'
          }"
        >
          {{ getContractStatus(contract.status).message }}
        </span>
      </div>
    </div>
  </div>
</td>

                            <td class="p-4 text-sm text-westetics-neutral-950">
                                <div class="flex items-center gap-2">
                                    <button 
                                        *ngIf="hasAnyPendingDocument(document)"
                                        (click)="openResendModal(document.answer_group_id)"
                                        [disabled]="resendLoading === document.answer_group_id"
                                        class="p-2 rounded-lg hover:bg-westetics-purple-100 text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                        title="Reenviar link de assinatura"
                                    >
                                        <fa-icon *ngIf="resendLoading !== document.answer_group_id" [icon]="faPaperPlane"></fa-icon>
                                        <app-loading-spinner *ngIf="resendLoading === document.answer_group_id" size="xs"></app-loading-spinner>
                                    </button>
                                    <!-- Botão Excluir -->
                                    <div class="relative inline-block"
                                         (mouseenter)="showLockTooltip($event, document.answer_group_id)"
                                         (mouseleave)="hideLockTooltip()"
                                    >
                                        <button
                                            class="p-2 rounded-lg hover:bg-gray-100 text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                            (click)="deleteDocument(document.answer_group_id)"
                                            [disabled]="!canDeleteDocument(document)"
                                            aria-label="Excluir documento"
                                        >
                                            <fa-icon [icon]="faTrash"></fa-icon>
                                        </button>
                                        <!-- Tooltip -->
                                        <div *ngIf="lockTooltipVisibleFor === document.answer_group_id"
                                             [ngStyle]="{ position: 'fixed', left: lockTooltipLeft + 'px', top: lockTooltipTop + 'px', transform: 'translateX(-100%)' }">
                                            <div class="bg-gray-800 text-white text-xs rounded px-2 py-1 flex items-center gap-2 whitespace-nowrap shadow-lg">
                                                <fa-icon [icon]="faLock" class="w-3 h-3"></fa-icon>
                                                <span>{{modulesService.moduleNameInSingular}} já assinou</span>
                                            </div>
                                        </div>
                                    </div>
                                    <span *ngIf="!hasAnyPendingDocument(document)" class="text-gray-400 text-xs">-</span>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="documents.length === 0">
                            <td colspan="7" class="p-8 text-center text-gray-500">
                                Nenhum documento encontrado.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Cards de Documentos - MOBILE -->
            <div class="md:hidden space-y-3 mb-4">
                <div *ngFor="let document of documents" 
                     class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
                    <div class="flex justify-between items-start mb-3">
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-semibold text-westetics-neutral-950">{{document.answered_at | date: 'dd/MM/yyyy'}}</p>
                            <p *ngIf="vm.moduleName === 'PACIENTES'" class="text-xs text-westetics-neutral-600 truncate">{{document.procedure_name || '-'}}</p>
                        </div>
                        <button
                            *ngIf="hasAnyPendingDocument(document)"
                            (click)="openResendModal(document.answer_group_id)"
                            [disabled]="resendLoading === document.answer_group_id"
                            class="p-2 text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors disabled:opacity-50"
                            title="Reenviar link de assinatura"
                        >
                            <fa-icon *ngIf="resendLoading !== document.answer_group_id" [icon]="faPaperPlane"></fa-icon>
                            <app-loading-spinner *ngIf="resendLoading === document.answer_group_id" size="xs"></app-loading-spinner>
                        </button>
                        <!-- Botão Excluir para mobile com tooltip (quando desabilitado) -->
                        <div class="relative inline-block ml-2"
                             (mouseenter)="showLockTooltip($event, document.answer_group_id)"
                             (mouseleave)="hideLockTooltip()"
                        >
                            <button
                                class="p-2 rounded-lg hover:bg-gray-100 text-westetics-purple-800 hover:text-westetics-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                (click)="deleteDocument(document.answer_group_id)"
                                [disabled]="!canDeleteDocument(document)"
                                aria-label="Excluir documento"
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.2812 3.9L14.4812 5.7H5.6999V18.3H18.2999V9.5187L20.0999 7.7187V19.2C20.0999 19.4387 20.0051 19.6676 19.8363 19.8364C19.6675 20.0052 19.4386 20.1 19.1999 20.1H4.7999C4.56121 20.1 4.33229 20.0052 4.16351 19.8364C3.99472 19.6676 3.8999 19.4387 3.8999 19.2V4.8C3.8999 4.5613 3.99472 4.33238 4.16351 4.1636C4.33229 3.99482 4.56121 3.9 4.7999 3.9H16.2812ZM19.6364 3.09L20.9099 4.3644L12.6371 12.6372L11.3663 12.6399L11.3645 11.3646L19.6364 3.09Z" fill="currentColor" />
                                </svg>
                            </button>

                            <div *ngIf="lockTooltipVisibleFor === document.answer_group_id" [ngStyle]="{ position: 'fixed', left: lockTooltipLeft + 'px', top: lockTooltipTop + 'px', transform: 'translateX(-100%)' }">
                                <div class="bg-gray-800 text-white text-xs rounded px-2 py-1 flex items-center gap-2 whitespace-nowrap shadow-lg">
                                    <fa-icon [icon]="faLock" class="w-3 h-3"></fa-icon>
                                    <span>{{modulesService.moduleNameInSingular}} já assinou</span>
                                </div>
                            </div>
                        </div>
                        <span *ngIf="!hasAnyPendingDocument(document)" class="p-2 text-gray-400 text-xs">-</span>
                    </div>
                    <div class="grid grid-cols-2 gap-2 text-xs mb-3">
                        <div *ngIf="vm.moduleName === 'PACIENTES'">
                            <span class="text-westetics-neutral-500">Profissional:</span>
                            <span class="ml-1 text-westetics-neutral-900">{{document.professional_name || '-'}}</span>
                        </div>
                        <div>
                            <span class="text-westetics-neutral-500">Valor:</span>
                            <span class="ml-1 text-westetics-neutral-900">{{document.total_value ? (document.total_value | currency:'BRL':'symbol':'1.2-2') : '-'}}</span>
                        </div>
                    </div>
                    <!-- Contratos -->
                    <div *ngIf="document.autentique_info_list && document.autentique_info_list.length > 0" class="border-t border-gray-100 pt-3">
                        <p class="text-xs font-medium text-westetics-neutral-700 mb-2">Contratos:</p>
                        <div *ngFor="let contract of document.autentique_info_list" class="flex justify-between items-center py-1.5 text-xs">
                            <div class="flex items-center gap-1 cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600"
                                 (click)="openContract(contract.document_id)">
                                <span class="truncate max-w-[140px]">{{contract.document_name}}</span>
                                <fa-icon [icon]="faExternalLinkAlt" class="text-[10px]"></fa-icon>
                            </div>
                            <span class="px-2 py-0.5 rounded-full text-xs font-medium"
                                [ngClass]="{
                                    'bg-westetics-purple-300 text-white': contract.status === 'SIGNED',
                                    'bg-red-300 text-white': contract.status === 'PENDING' || contract.status === 'NOT_SIGNED',
                                    'bg-yellow-300 text-white': contract.status === 'SIGNED_ONLY_BY_RESPONSIBLE' || contract.status === 'SIGNED_ONLY_BY_CLIENT' || contract.status === 'PENDING_RESPONSIBLE',
                                    'bg-blue-300 text-white': getContractStatus(contract.status).message === 'Pendente'
                                }">
                                {{getContractStatus(contract.status).message}}
                            </span>
                        </div>
                    </div>
                </div>
                <div *ngIf="documents.length === 0" class="bg-white rounded-lg border border-gray-200 p-8 text-center text-gray-500">
                    Nenhum documento encontrado.
                </div>
            </div>

            <!-- Paginação Documentos -->
            <div *ngIf="documents.length > 0 && documentsTotalPages > 1" class="flex flex-col sm:flex-row items-center justify-between gap-4 py-4 px-2 sm:px-5">
                <!-- Info de resultados -->
                <div class="text-xs sm:text-sm text-gray-600">
                    Página {{ documentsCurrentPage + 1 }} de {{ documentsTotalPages }}
                </div>
                
                <!-- Controles de paginação -->
                <div class="flex items-center gap-1 sm:gap-2">
                    <!-- Botão Anterior -->
                    <button (click)="documentsPrevious()" 
                            [disabled]="documentsCurrentPage === 0"
                            [ngClass]="{'opacity-50 cursor-not-allowed': documentsCurrentPage === 0}"
                            class="px-2 sm:px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                        </svg>
                    </button>
                    
                    <!-- Números das páginas -->
                    <div class="flex items-center gap-1">
                        <ng-container *ngFor="let page of generatePagination(documentsCurrentPage + 1, documentsTotalPages)">
                            <button
                                (click)="documentsNavigateTo(page)"
                                [ngClass]="{
                                    'bg-westetics-purple-600 text-white': page === documentsCurrentPage + 1,
                                    'hover:bg-gray-50': page !== documentsCurrentPage + 1
                                }"
                                class="min-w-[32px] sm:min-w-[36px] px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-300 rounded-md transition-colors text-xs sm:text-sm">
                                {{ page }}
                            </button>
                        </ng-container>
                    </div>
                    
                    <!-- Botão Próximo -->
                    <button (click)="documentsNext()" 
                            [disabled]="documentsCurrentPage + 1 >= documentsTotalPages"
                            [ngClass]="{'opacity-50 cursor-not-allowed': documentsCurrentPage + 1 >= documentsTotalPages}"
                            class="px-2 sm:px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                        </svg>
                    </button>
                </div>

                <!-- Seletor de itens por página -->
                <div class="flex items-center gap-2 text-xs sm:text-sm">
                    <span class="text-gray-600">Por página:</span>
                    <select [value]="documentsPageSize" (change)="changeDocumentsPageSize($event)"
                            class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
            </div>
        </div>

        <!-- ========== PLANOS DE TRATAMENTO ========== -->
        <div *ngIf="activeSection === 'planosTratamento'">
            
            <!-- Header com filtros -->
            <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-4 gap-3">
                <h2 class="text-base sm:text-lg font-semibold text-westetics-neutral-950">Planos de Tratamento</h2>
                <div class="flex gap-2">
                    <button (click)="changeTreatmentPlansStatusFilter('ACTIVE')"
                        class="px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm transition-colors"
                        [ngClass]="treatmentPlansStatusFilter === 'ACTIVE' ? 'bg-westetics-purple-800 text-white hover:bg-westetics-purple-600' : 'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border'">
                        Em Aberto
                    </button>
                    <button (click)="changeTreatmentPlansStatusFilter('CLOSED')"
                        class="px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm transition-colors"
                        [ngClass]="treatmentPlansStatusFilter === 'CLOSED' ? 'bg-westetics-purple-800 text-white hover:bg-westetics-purple-600' : 'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border'">
                        Encerrados
                    </button>
                </div>
            </div>

            <!-- Loading -->
            <div *ngIf="loadingTreatmentPlans" class="flex justify-center py-8">
                <app-loading-spinner size="md"></app-loading-spinner>
            </div>

            <!-- Mensagem de lista vazia -->
            <div *ngIf="!loadingTreatmentPlans && treatmentPlans.length === 0" class="bg-white rounded-lg border border-gray-200 p-8 text-center text-gray-500">
                Nenhum plano de tratamento encontrado.
            </div>

            <!-- Tabela de Planos de Tratamento - DESKTOP -->
            <div *ngIf="!loadingTreatmentPlans && treatmentPlans.length > 0" class="hidden md:block overflow-x-auto rounded-lg">
                <table class="w-full text-sm text-left text-gray-500 mb-4">
                    <thead class="text-xs text-westetics-neutral-900 bg-westetics-neutral-300">
                        <tr class="text-left">
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Data de Criação
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm w-[40%]">
                                Procedimentos
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Profissional
                            </th>
                            <th scope="col" class="px-4 py-2 font-medium text-nowrap text-sm">
                                Valor Total
                            </th>
                            <!-- Status column title removed -->
                            <th scope="col" class="px-4 py-2 font-medium text-sm">
                                Ações
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let plan of treatmentPlans" class="border-b hover:bg-gray-50 cursor-pointer" (click)="viewTreatmentPlan(plan.id)">
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{ formatTreatmentPlanDate(plan.created_at) }}
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950 max-w-[420px]">
                                <span [title]="plan.contracted_procedures || ''">
                                    {{ (plan.contracted_procedures?.length || 0) > 40 ? (plan.contracted_procedures | slice:0:40) + '...' : (plan.contracted_procedures || '-') }}
                                </span>
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{ plan.responsible_professional || '-' }}
                            </td>
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                {{ formatTreatmentPlanCurrency(plan.total_value) }}
                            </td>
                            <!-- Status cell removed -->
                            <td class="p-4 text-sm text-westetics-neutral-950">
                                <button (click)="viewTreatmentPlan(plan.id); $event.stopPropagation()" 
                                    class="p-2 text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                                    title="Visualizar plano">
                                    <fa-icon [icon]="faEye"></fa-icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Cards de Planos de Tratamento - MOBILE -->
            <div *ngIf="!loadingTreatmentPlans && treatmentPlans.length > 0" class="md:hidden space-y-3 mb-4">
                <div *ngFor="let plan of treatmentPlans" 
                     class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
                    <div class="flex justify-between items-start mb-3">
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-semibold text-westetics-neutral-950">{{ formatTreatmentPlanDate(plan.created_at) }}</p>
                            <p class="text-xs text-westetics-neutral-600 truncate" [title]="plan.contracted_procedures || ''">
                                {{ (plan.contracted_procedures?.length || 0) > 30 ? (plan.contracted_procedures | slice:0:30) + '...' : (plan.contracted_procedures || '-') }}
                            </p>
                        </div>
                        <button (click)="viewTreatmentPlan(plan.id)" 
                            class="p-2 text-westetics-purple-800 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                            title="Visualizar plano">
                            <fa-icon [icon]="faEye"></fa-icon>
                        </button>
                    </div>
                    <div class="grid grid-cols-2 gap-2 text-xs">
                        <div>
                            <span class="text-westetics-neutral-500">Profissional:</span>
                            <span class="ml-1 text-westetics-neutral-900">{{ plan.responsible_professional || '-' }}</span>
                        </div>
                        <div>
                            <span class="text-westetics-neutral-500">Valor:</span>
                            <span class="ml-1 text-westetics-neutral-900">{{ formatTreatmentPlanCurrency(plan.total_value) }}</span>
                        </div>
                        <!-- Mobile status removed -->
                    </div>
                </div>
            </div>

            <!-- Paginação Planos de Tratamento -->
            <div *ngIf="!loadingTreatmentPlans && treatmentPlans.length > 0 && treatmentPlansTotalPages > 1" class="flex flex-col sm:flex-row items-center justify-between gap-4 py-4 px-2 sm:px-5">
                <!-- Info de resultados -->
                <div class="text-xs sm:text-sm text-gray-600">
                    Página {{ treatmentPlansCurrentPage + 1 }} de {{ treatmentPlansTotalPages }}
                </div>
                
                <!-- Controles de paginação -->
                <div class="flex items-center gap-1 sm:gap-2">
                    <!-- Botão Anterior -->
                    <button (click)="treatmentPlansPrevious()" 
                            [disabled]="treatmentPlansCurrentPage === 0"
                            [ngClass]="{'opacity-50 cursor-not-allowed': treatmentPlansCurrentPage === 0}"
                            class="px-2 sm:px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                        </svg>
                    </button>
                    
                    <!-- Números das páginas -->
                    <div class="flex items-center gap-1">
                        <ng-container *ngFor="let page of generatePagination(treatmentPlansCurrentPage + 1, treatmentPlansTotalPages)">
                            <button
                                (click)="treatmentPlansNavigateTo(page)"
                                [ngClass]="{
                                    'bg-westetics-purple-600 text-white': page === treatmentPlansCurrentPage + 1,
                                    'hover:bg-gray-50': page !== treatmentPlansCurrentPage + 1
                                }"
                                class="min-w-[32px] sm:min-w-[36px] px-2 sm:px-3 py-1.5 sm:py-2 border border-gray-300 rounded-md transition-colors text-xs sm:text-sm">
                                {{ page }}
                            </button>
                        </ng-container>
                    </div>
                    
                    <!-- Botão Próximo -->
                    <button (click)="treatmentPlansNext()" 
                            [disabled]="treatmentPlansCurrentPage + 1 >= treatmentPlansTotalPages"
                            [ngClass]="{'opacity-50 cursor-not-allowed': treatmentPlansCurrentPage + 1 >= treatmentPlansTotalPages}"
                            class="px-2 sm:px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                        </svg>
                    </button>
                </div>

                <!-- Seletor de itens por página -->
                <div class="flex items-center gap-2 text-xs sm:text-sm">
                    <span class="text-gray-600">Por página:</span>
                    <select [value]="treatmentPlansPageSize" (change)="changeTreatmentPlansPageSize($event)"
                            class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
            </div>
        </div>

    </div>
</div>
<!-- MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE DOCUMENTO -->
<div *ngIf="showConfirmDeletePopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-[480px] shadow-lg">
        <div class="flex justify-between items-center mb-4">
            <h2 class="font-bold text-lg text-westetics-neutral-950">Confirmar exclusão</h2>
            <button (click)="closeDeleteModal()" class="text-westetics-neutral-600 hover:text-westetics-neutral-900">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>
        <p class="text-base font-medium text-westetics-neutral-950 mb-2">Confirmar exclusão</p>
        <p class="text-sm text-westetics-neutral-800 mb-6">
            Tem certeza que deseja excluir este documento? Esta ação não pode ser desfeita.
        </p>
        <div class="flex justify-end gap-3">
            <button id="confirm-delete-cancel-btn" (click)="closeDeleteModal()"
                class="px-4 py-2 text-sm font-medium rounded-lg text-westetics-purple-800 hover:bg-westetics-purple-800 border-westetics-purple-800 border hover:text-white">
                Cancelar
            </button>
            <button (click)="confirmDelete()"
                [disabled]="confirmDeleteLoading"
                class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-300 disabled:opacity-50 disabled:cursor-not-allowed">
                <ng-container *ngIf="!confirmDeleteLoading">Excluir</ng-container>
                <div *ngIf="confirmDeleteLoading" class="flex items-center gap-2">
                    <app-loading-spinner size="xs"></app-loading-spinner>
                    <span>Excluindo...</span>
                </div>
            </button>
        </div>
    </div>
</div>
</ng-container>

<!-- MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE ANAMNESE -->
<div *ngIf="showConfirmDeleteAnamnesePopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-[480px] shadow-lg">
        <div class="flex justify-between items-center mb-4">
            <h2 class="font-bold text-lg text-westetics-neutral-950">Confirmar exclusão</h2>
            <button (click)="closeAnamneseDeleteModal()" class="text-westetics-neutral-600 hover:text-westetics-neutral-900">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>
        <p class="text-base font-medium text-westetics-neutral-950 mb-2">Confirmar exclusão</p>
        <p class="text-sm text-westetics-neutral-800 mb-6">
            Tem certeza que deseja excluir este formulário? Esta ação não pode ser desfeita.
        </p>
        <div class="flex justify-end gap-3">
            <button id="confirm-delete-anamnese-cancel-btn" (click)="closeAnamneseDeleteModal()"
                    class="px-4 py-2 text-sm font-medium text-westetics-purple-800 hover:bg-westetics-purple-800 border-westetics-purple-800 border rounded-lg hover:text-white">
                    Cancelar
            </button>
            <button (click)="confirmDeleteAnamnese()"
                    [disabled]="confirmDeleteAnamneseLoading"
                    class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-300 disabled:opacity-50 disabled:cursor-not-allowed">
                    <ng-container *ngIf="!confirmDeleteAnamneseLoading">Excluir</ng-container>
                    <div *ngIf="confirmDeleteAnamneseLoading" class="flex items-center gap-2">
                            <app-loading-spinner size="xs"></app-loading-spinner>
                            <span>Excluindo...</span>
                    </div>
            </button>
        </div>
    </div>
</div>

<!-- Modal Enviar Anamnese -->
<div *ngIf="showAnamneseModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 w-[480px] shadow-lg">
        
        <!-- Loading -->
        <div *ngIf="anamneseModalLoading" class="flex justify-center items-center py-8">
            <app-loading-spinner size="md"></app-loading-spinner>
        </div>

        <!-- Confirmar Anamnese (tem anamnese anterior e NÃO tem em andamento) -->
        <div *ngIf="!anamneseModalLoading && hasPreviousAnamnese && !hasUnansweredAnamnese">
            <div class="flex justify-between items-center mb-4">
                <h2 class="font-bold text-lg text-westetics-neutral-950">Enviar Anamnese</h2>
                <button (click)="closeAnamneseModal()" class="text-westetics-neutral-600 hover:text-westetics-neutral-900">
                    <fa-icon [icon]="faTimes"></fa-icon>
                </button>
            </div>
            <p class="text-base font-medium text-westetics-neutral-950 mb-2">Confirmar anamnese</p>
            <p class="text-sm text-westetics-neutral-800 mb-6">
                Deseja reutilizar os dados da Anamnese anterior?
            </p>
            <div class="flex justify-between gap-3">
                <div class="flex gap-2">
                    <button
                        (click)="onConfirmAnamnese(true)"
                        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600"
                    >
                        Reutilizar
                    </button>
                    <button
                        (click)="onConfirmAnamnese(false)"
                        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600"
                    >
                        Nova Anamnese
                    </button>
                </div>
                <button
                    (click)="closeAnamneseModal()"
                    class="px-4 py-2 text-sm font-medium text-westetics-neutral-800 bg-westetics-neutral-200 rounded-lg hover:bg-westetics-neutral-300"
                >
                    Cancelar
                </button>
            </div>
        </div>

        <!-- Anamnese em Andamento -->
        <div *ngIf="!anamneseModalLoading && hasUnansweredAnamnese">
            <div class="flex justify-between items-center mb-4">
                <h2 class="font-bold text-lg text-westetics-neutral-950">Anamnese em andamento</h2>
                <button (click)="closeAnamneseModal()" class="text-westetics-neutral-600 hover:text-westetics-neutral-900">
                    <fa-icon [icon]="faTimes"></fa-icon>
                </button>
            </div>
            <p class="text-sm text-westetics-neutral-800 mb-1">Existe uma anamnese já em andamento!</p>
            <p class="text-sm text-westetics-neutral-800 mb-6">O que deseja fazer com ela?</p>
            <div class="flex justify-between gap-3">
                <div class="flex gap-2">
                    <button
                        (click)="onAccessOngoingAnamnese()"
                        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600"
                    >
                        Acessar
                    </button>
                    <button
                        (click)="onDeleteOngoingAnamnese()"
                        class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600"
                    >
                        Excluir e gerar nova
                    </button>
                </div>
                <button
                    (click)="closeAnamneseModal()"
                    class="px-4 py-2 text-sm font-medium text-westetics-neutral-800 bg-westetics-neutral-200 rounded-lg hover:bg-westetics-neutral-300"
                >
                    Cancelar
                </button>
            </div>
        </div>

        <!-- Sem Anamnese Anterior (criar nova direto) -->
        <div *ngIf="!anamneseModalLoading && !hasPreviousAnamnese && !hasUnansweredAnamnese">
            <div class="flex justify-between items-center mb-4">
                <h2 class="font-bold text-lg text-westetics-neutral-950">Enviar Anamnese</h2>
                <button (click)="closeAnamneseModal()" class="text-westetics-neutral-600 hover:text-westetics-neutral-900">
                    <fa-icon [icon]="faTimes"></fa-icon>
                </button>
            </div>
            <p class="text-sm text-westetics-neutral-800 mb-6">
                Deseja enviar uma nova anamnese para este paciente?
            </p>
            <div class="flex justify-end gap-3">
                <button
                    (click)="closeAnamneseModal()"
                    class="px-4 py-2 text-sm font-medium text-westetics-neutral-800 bg-westetics-neutral-200 rounded-lg hover:bg-westetics-neutral-300"
                >
                    Cancelar
                </button>
                <button
                    (click)="onConfirmAnamnese(false)"
                    class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-600"
                >
                    Enviar Anamnese
                </button>
            </div>
        </div>

    </div>
</div>

<!-- MODAL DE REENVIO DE DOCUMENTOS -->
<div 
    *ngIf="showResendModal" 
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    (click)="closeResendModal()"
>
    <div 
        class="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 max-h-[80vh] overflow-y-auto"
        (click)="$event.stopPropagation()"
    >
        <!-- Header -->
        <div class="flex items-center justify-between p-4 border-b">
            <h3 class="text-lg font-semibold text-westetics-neutral-950">Reenviar Links de Assinatura</h3>
            <button 
                (click)="closeResendModal()"
                class="p-1 hover:bg-gray-100 rounded transition-colors"
            >
                <fa-icon [icon]="faTimes" class="text-gray-500"></fa-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="p-4">
            <!-- Loading -->
            <div *ngIf="resendModalLoading" class="flex justify-center py-8">
                <app-loading-spinner size="md"></app-loading-spinner>
            </div>

            <!-- Error -->
            <div *ngIf="resendError" class="bg-red-50 text-red-700 p-4 rounded-lg">
                {{ resendError }}
            </div>

            <!-- Documents List -->
            <div *ngIf="resendDocumentsData && !resendModalLoading">
                <p class="text-sm text-westetics-neutral-600 mb-4">
                    <fa-icon [icon]="faInfoCircle" class="mr-1"></fa-icon>
                    Copie o(s) link(s) abaixo e envie para o {{modulesService.moduleNameInSingular | lowercase}} assinar os documentos.
                </p>

                <div class="space-y-3 mb-4">
                    <div 
                        *ngFor="let doc of resendDocumentsData.documents" 
                        class="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
                    >
                        <div class="flex-1 min-w-0">
                            <p class="font-medium text-sm text-westetics-neutral-950 truncate">{{ doc.document_name }}</p>
                            <p class="text-xs text-gray-500 truncate">{{ doc.signature_url }}</p>
                        </div>
                        <button 
                            (click)="copyLink(doc.signature_url)"
                            class="ml-3 p-2 hover:bg-gray-200 rounded transition-colors"
                            title="Copiar link"
                        >
                            <fa-icon [icon]="faCopy" class="text-westetics-purple-800"></fa-icon>
                        </button>
                    </div>
                </div>

                <!-- Copy All Button -->
                <button 
                    (click)="copyWhatsAppMessage()"
                    class="w-full py-3 px-4 rounded-lg bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white transition-colors font-medium flex items-center justify-center gap-2"
                >
                    <fa-icon [icon]="faCopy"></fa-icon>
                    Copiar mensagem para WhatsApp
                </button>
            </div>
        </div>
    </div>
</div>


